import Flex from "common/Boxes/Flex";
import IconWithFallback, { IconSize } from "Global/IconWithFallback";
import Text from "common/Typography/Text";
import { ICON_TYPES } from "@shared/common/constants";
import { CSSProperties } from "react";
import styled, { useTheme } from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface AccountAndExchangeProps {
  account: string;
  exchange: string;
  style?: CSSProperties;
  iconSize?: IconSize;
  iconStyle?: CSSProperties;
  ellipsis?: boolean;
}

const AccountAndExchange = ({
  account,
  exchange,
  style,
  iconSize,
  iconStyle,
  ellipsis,
}: AccountAndExchangeProps) => {
  const { isNewLook } = useTheme();
  if (isNewLook)
    return (
      <NewLookRow style={style}>
        <IconWithFallback
          iconType={ICON_TYPES.EXCHANGE}
          coinOrExchangeName={exchange}
          pxIconSize={24}
          iconStyle={iconStyle}
        />
        <NewLookNames>
          <NewLookName $ellipsis={ellipsis} title={account}>
            {account}
          </NewLookName>
          <NewLookExchange $ellipsis={ellipsis}>{exchange}</NewLookExchange>
        </NewLookNames>
      </NewLookRow>
    );
  return (
    <Flex
      $alignItems="center"
      $justifyContent="flex-start"
      style={{ minWidth: 150, ...style }}
    >
      <IconWithFallback
        iconType={ICON_TYPES.EXCHANGE}
        coinOrExchangeName={exchange}
        iconStyle={{ marginRight: 16, ...iconStyle }}
        iconSize={iconSize ?? "xxxl"}
      />
      <Flex
        $flexDirection="column"
        $alignItems="flex-start"
        style={ellipsis ? { overflow: "hidden" } : undefined}
      >
        <Text $ellipsis={ellipsis}>{account}</Text>
        <Text type={"secondary"} style={{ marginTop: 4 }} $ellipsis={ellipsis}>
          {exchange}
        </Text>
      </Flex>
    </Flex>
  );
};

export default AccountAndExchange;

const NewLookRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 150px;
`;
const NewLookNames = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;
const ellipsisStyle = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const NewLookName = styled.span<{ $ellipsis?: boolean }>`
  ${newLookType.panelTitle};
  color: ${(p) => getNewLookTokens(p.theme).ink};
  ${(p) => p.$ellipsis && ellipsisStyle}
`;
const NewLookExchange = styled.span<{ $ellipsis?: boolean }>`
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
  ${(p) => p.$ellipsis && ellipsisStyle}
`;
